const PackageSelect = () => import('@pages/mes/PackageSelect')
const MesDoctor = () => import('@pages/mes/MesDoctor')
const PackageDetail = () => import('@pages/mes/PackageDetail')
const ItemSelect = () => import('@pages/mes/ItemSelect')
const SheetItemSelect = () => import('@pages/mes/SheetItemSelect')
const OrderConfirm = () => import('@pages/mes/OrderConfirm')
const OrderDetail = () => import('@pages/mes/OrderDetail')
const OrderList = () => import('@pages/mes/OrderList')
const OrderPayment = () => import('@pages/mes/OrderPayment')
const PackageSchedule = () => import('@pages/mes/PackageSchedule')
const PackageItem = () => import('@pages/mes/PackageItem')
const MesGroup = () => import('@pages/mes/MesGroup')
const Report = () => import('@pages/mes/Report')
const ReportSeek = () => import('@pages/mes/ReportSeek')
const Navigation = () => import('@pages/mes/Navigation')
const ReportSeekEvaluate = () => import('@pages/mes/ReportSeekEvaluate')
const OrderMail = () => import('@pages/mes/OrderMail')
const OrderMailPayment = () => import('@pages/mes/OrderMailPayment')
const OrderOpinion = () => import('@pages/mes/OrderOpinion')
const MailApplication = () => import('@pages/mes/MailApplication')
const MesMenu = () => import('@pages/mes/Menu')
const MesGuide = () => import('@pages/mes/Guide')
const GroupSearch = () => import('@pages/mes/Group/Search')
const GroupBatch = () => import('@pages/mes/Group/Batch')
const GroupShow = () => import('@pages/mes/Group/Show')
const ImageShow = () => import('@pages/mes/ImageShow')
const ImageList = () => import('@pages/mes/ImageList')
const ReportList = () => import('@pages/mes/ReportList')
const SingleList = () => import('@pages/mes/SingleList')
const OrderSign = () => import('@pages/mes/OrderSign')
const CovidShow = () => import('@pages/mes/CovidShow')
const ExaminationProcess = () => import('@pages/mes/ExaminationProcess')
const PatientBodyIndicator = () => import('@pages/mes/PatientBodyIndicator/PatientBodyIndicator')
const PatientIndicatorReport = () => import('@pages/mes/PatientBodyIndicator/IndicatorReport')
const SexSelect = () => import('@pages/mes/SexSelect')

export const mes = [
  {
    path: '/mes/image',
    name: 'ImageShow',
    component: ImageShow,
    meta: {}
  },
  {
    path: '/mes/list',
    name: 'ImageList',
    component: ImageList,
    meta: {}
  },
  {
    path: '/mes/packages',
    name: 'PackageSelect',
    component: PackageSelect,
    meta: {}
  },
  {
    path: '/mes/doctors',
    name: 'MesDoctor',
    component: MesDoctor,
    meta: {}
  },
  {
    path: '/mes/package/:id',
    name: 'PackageDetail',
    component: PackageDetail,
    meta: {}
  },
  {
    path: '/mes/:packageId/items',
    name: 'ItemSelect',
    component: ItemSelect,
    meta: {title: '增加项目'}
  },
  {
    path: '/mes/:packageId/sheet',
    name: 'SheetItemSelect',
    component: SheetItemSelect,
    meta: {title: '项目编辑'}
  },
  {
    path: '/reg/pay/mes',
    name: 'OrderConfirm',
    component: OrderConfirm,
    meta: {title: '预定信息'}
  },
  {
    path: '/mes/order/:id',
    name: 'OrderDetail',
    component: OrderDetail,
    meta: {title: '订单信息'}
  },
  {
    path: '/mes/orders',
    name: 'OrderList',
    component: OrderList,
    meta: {}
  },
  {
    path: '/reg/pay/mes_order',
    name: 'OrderPayment',
    component: OrderPayment,
    meta: {}
  },
  {
    path: '/mes/package/:id/schedule',
    name: 'PackageSchedule',
    component: PackageSchedule,
    meta: {}
  },
  {
    path: '/mes/package/:id/item',
    name: 'PackageItem',
    component: PackageItem,
    meta: {}
  },
  {
    path: '/mes/package/mes_group',
    name: 'MesGroup',
    component: MesGroup,
    meta: {}
  },
  {
    path: '/mes/report/:id',
    name: 'Report',
    component: Report,
    meta: {}
  },
  {
    path: '/mes/report_seek',
    name: 'ReportSeek',
    component: ReportSeek,
    meta: {}
  },
  {
    path: '/mes/navigation',
    name: 'Navigation',
    component: Navigation,
    meta: {}
  },
  {
    path: '/mes/report_seek_evaluate/:id',
    name: 'ReportSeekEvaluate',
    component: ReportSeekEvaluate,
    meta: {}
  },
  {
    path: '/mes/order_mail',
    name: 'OrderMail',
    component: OrderMail,
    meta: {}
  },
  {
    path: '/reg/pay/mes_order_mail',
    name: 'OrderMailPayment',
    component: OrderMailPayment,
    meta: {}
  },
  {
    path: '/mes/order_opinion/:id',
    name: 'OrderOpinion',
    component: OrderOpinion,
    meta: {}
  },
  {
    path: '/mes/mail_application',
    name: 'MailApplication',
    component: MailApplication,
    meta: {}
  },
  {
    path: '/mes/menu',
    name: 'MesMenu',
    component: MesMenu,
    meta: {}
  },
  {
    path: '/mes/guide',
    name: 'MesGuide',
    component: MesGuide,
    meta: {}
  },
  {
    path: '/mes/group/search',
    name: 'GroupSearch',
    component: GroupSearch,
    meta: {}
  },
  {
    path: '/mes/group/batch',
    name: 'GroupBatch',
    component: GroupBatch,
    meta: {}
  },
  {
    path: '/mes/group/show',
    name: 'GroupShow',
    component: GroupShow,
    meta: {}
  },
  {
    path: '/mes/reports',
    name: 'ReportList',
    component: ReportList,
    meta: {}
  },
  {
    path: '/mes/singles/:id',
    name: 'SingleList',
    component: SingleList,
    meta: {}
  },
  {
    path: '/mes/sex',
    name: 'SexSelect',
    component: SexSelect,
    meta: {}
  },
  {
    path: '/mes/order_sign',
    name: 'OrderSign',
    component: OrderSign,
    meta: {}
  },
  {
    path: '/mes/covid_show/:id_card',
    name: 'CovidShow',
    component: CovidShow,
    meta: {}
  },
  {
    path: '/mes/examination_process',
    name: 'ExaminationProcess',
    component: ExaminationProcess,
    meta: {auth: false}
  },
  {
    path: '/mes/patient_body_indicator',
    name: 'PatientBodyIndicator',
    component: PatientBodyIndicator,
    meta: {}
  },
  {
    path: '/mes/indicator_report',
    name: 'PatientBodyReport',
    component: PatientIndicatorReport,
    meta: {}
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/mes.route.js